/** declare only http service related requests */

import { HttpTokens, GetIncidentsDashboardCharts, QueryIncidentsDashboardCharts } from '@/src/types';
import { paramsQueryString } from '@/src/utils';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description Get incidents chart data statistics on dashboard
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const IncidentDashboardChartsGet = (
  prefix: string = 'incidents/dashboard/charts',
  query: QueryIncidentsDashboardCharts,
  tokens: HttpTokens,
  hardRejection = true
): Promise<GetIncidentsDashboardCharts> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  // token not yet set on backend
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };
  const queryUri = paramsQueryString(prefix, query || {});

  return instance.client
    .get(queryUri, config)
    .then((d: AxiosResponse<GetIncidentsDashboardCharts>) => {
      // return Promise.reject(new Error('ups')) as any;
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<GetIncidentsDashboardCharts>;
};
